<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
            label-width="70px">
            <el-form-item label="账户名" prop="username">
                <el-input v-model="searchForm.username" placeholder="账户名" style="width:  210px"></el-input>
            </el-form-item>
            <el-form-item label="入账方式" prop="destinationType">
                <el-select v-model="searchForm.destinationType" placeholder="请选择" style="width: 120px">
                    <el-option label="微信" :value="0"></el-option>
                    <el-option label="银行卡" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="到账方式" prop="transactType">
                <el-select v-model="searchForm.transactType" placeholder="请选择" style="width: 120px">
                    <el-option :label="item.name" :value="item.value" v-for="(item,key) in typeList" :key="key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间" prop="selectTime">
                <el-date-picker v-model="selectTime" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :clearable="false"
                    key="picker1" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"  style="width: 230px"
                    @change="handleChangeDate"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table border size="small" style="width:100%;margin-top:10px;" :data="tableData" v-loading="isLoading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-table-column type="index" label="#" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"  width="160"></el-table-column>
            <el-table-column prop="username" label="账户名" width="120"></el-table-column>
            <el-table-column prop="amount" label="变动金额" width="150"></el-table-column>
            <el-table-column prop="balance" label="余额" width="150"></el-table-column>
            <el-table-column prop="refResourceId" label="关联订单号" width="180"></el-table-column>
            <el-table-column prop="creditMoneyType" label="类型" width="120">
                <template slot-scope="{ row }">
                    <el-tag v-if="row.creditMoneyType == 1">收入</el-tag>
                    <el-tag type="danger" v-if="row.creditMoneyType == 2">支出</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="transactTypeDesc" label="到账方式" width="120">
                <template slot-scope="{ row }">
                    <el-tag>{{ row.transactTypeDesc }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="destinationTypeDesc" label="入账方式" width="100">
                <template slot-scope="{ row }">
                    <el-tag>{{ row.destinationTypeDesc }}</el-tag>
                    <!-- <el-tag v-if="row.destinationType == 2">银行卡</el-tag> -->
                    <!-- <el-tag v-if="row.destinationType == 3">余额</el-tag> -->
                </template>
            </el-table-column>
            <el-table-column prop="detail" label="描述" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="phone" label="分账时间" width="170"></el-table-column> -->
        </el-table>
        <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
            style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
            :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>

    </div>
</template>

<script>
import { dateFormat } from "@/utils/dateTime"
export default {
    name: "statementRecord",
    data() {

        return {
            map: null,
            searchForm: {
                destinationType: "",
                destinationType: "",
                transactType: "",
                startDate: "",
                endDate: "",
                pageSize: 10,
                pageNumber: 1,
            },
            selectTime: null,
            isLoading: false,
            tableData: [],
            total: 0,
            typeList: []
            
        }
    },
    methods: {
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                username: "",
                destinationType: "",
                startDate: dateFormat(new Date(new Date().getTime() - 3600 * 1000 * 24 * 6 )),
                endDate: dateFormat(new Date()),
                pageSize: 10,
                pageNumber: 1,
            };
            this.selectTime = [this.searchForm.startDate, this.searchForm.endDate];
            this.getTableData();
        },

        handleChangeDate(date) {
            if (date.length) {
                this.searchForm.startDate = date[0];
                this.searchForm.endDate = date[1];
            }
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.getRequest("/api/balanceChange/getPageList", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data.records;
                        this.total = data.data.total;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        },
        getTransTypeList() {
            this.getRequest("/api/balanceChange/getAllTransactType")
            .then(res => {
                this.isLoading = false;
                let data = res.data;
                if (data.code == 200) {
                    this.typeList = data.data;
                }
            }).catch(() => {
                this.isLoading = false;
            })
        }
    },

    mounted() {
        this.searchForm = {
            name: "",
            transactType: "",
            transactType: '',
            startDate: dateFormat(new Date(new Date().getTime() - 3600 * 1000 * 24 * 6 )),
            endDate: dateFormat(new Date()),
            pageSize: 10,
            pageNumber: 1,
        };
        this.selectTime = [this.searchForm.startDate, this.searchForm.endDate];
        this.getTableData();
        this.getTransTypeList();
    },

}
</script>

<style type="less">
    @import url("./index.less");
</style>